import Card from '@/components/card';
import FormSection from '@/components/form/form-section';
import { FormHandle } from '@/hooks/use-form-handle.hook';
import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { FC } from 'react';

import ContentControlItemV1 from '../content-controls-v1/item';
import MetadataControlItemV1 from '../metadata-controls-v1/item';
import FormSectionSubtitle from '@/components/form/form-section/form-section-subtitle';

interface Props {
  policy: PolicyModelV1;
  orgPolicy?: PolicyModelV1;
  formHandle: FormHandle<PolicyModelV1>;
  readonly: boolean;
}

const ServiceControlsV1: FC<Props> = ({ formHandle, readonly, policy, orgPolicy }) => {
  return (
    <FormSection title="Service Controls" scrollId="service-controls">
      <FormSectionSubtitle>
        Service data is detected across various services and events. If the following service
        metadata is detected, choose the action to take.
      </FormSectionSubtitle>
      <Card>
        <MetadataControlItemV1
          controlType="non-licensed"
          formHandle={formHandle}
          readonly={readonly}
          policy={policy}
          orgPolicy={orgPolicy}
        />
        <MetadataControlItemV1
          controlType="enforce-data-privacy"
          formHandle={formHandle}
          readonly={readonly}
          policy={policy}
          orgPolicy={orgPolicy}
        />
        <ContentControlItemV1
          controlType="file-upload"
          formHandle={formHandle}
          readonly={readonly}
          policy={policy}
          orgPolicy={orgPolicy}
        />
      </Card>
    </FormSection>
  );
};

export default ServiceControlsV1;
